/**
 * @internal
 */
export const STICKY_PARAMS: string[] = [
  'perspective',
  'excludedPerspectives',
  'displayInlineChanges',
  'sidebar',
  'selectedTask',
  'viewMode',
]
